import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { ConfirmEventType, ConfirmationService, Message } from 'primeng/api';
import { breadcrumb, link } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { MsPermissionService } from 'src/app/services/ms-permission.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-factor-forwarding',
  templateUrl: './factor-forwarding.component.html',
  styleUrls: ['./factor-forwarding.component.scss', '../../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class FactorForwardingComponent {
  //Constants
  header: string = this.translate("Factors");
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Factors'), link: '/ms/factor' },
  ];

  factorStatusConstants = [
    { label: 'Pending', value: 'Pending' },
    { label: 'On-Hold', value: 'On-Hold' },
    { label: 'In-Progress', value: 'In-Progress' },
    { label: 'Challenge', value: 'Challenge' },
    { label: 'Done', value: 'Done' }
  ];

  //Toogling variables
  skelition: boolean = true;
  messages: Message[] = [];
  isInternalPM: boolean = false;
  showForwardModal: boolean = false;
  showApproveModal: boolean = false;
  showRedoModal: boolean = false;


  //Data variables
  projectId: string = '';
  channels: any;
  project: any;
  selectedBranches: any;
  basicChannels: any;
  factors: any[] = [];
  currentFactor: any;

  //Access Controll
  isJunior: boolean = false;

  pmComment: string = '';
  stepStatus: any = [];
  statusType: string = 'Pending';


  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      if (this.projectId) {
        this.links.push({
          name: this.translate('Back'),
          icon: 'pi pi-refresh',
          link: ''
        })
        Promise.all([
          this.getFactorData(),
          this.getProject(this.projectId),
        ]).then(() => {
          let pm = MsPermissionService.checkUserPermissions(this.project);
          if (pm == true) {
            this.isInternalPM = true;
          } else if (pm == false) {
            this.router.navigate(['/ms/project'])
            return;
          }
          if (!this.isInternalPM) {
            this.isJunior = this.router.url.includes('factor-update-status')
          }
          this.skelition = false
        })
      }
    })
  }

  openForwardModal(factor: any) {
    this.currentFactor = cloneDeep(factor);
    this.showForwardModal = true;
  }

  openRedoModal(factor: any) {
    this.currentFactor = cloneDeep(factor);
    this.showRedoModal = true;
  }

  confirmApprove(factor: any) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            channelId: factor.channel,
            branchId: factor.branch,
            factorId: factor._id,
            approvalStatus: 'Approved',
            repeat: 0
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-factors/status/approval', approveData, 'PUT', false);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.getFactorData().then(() => this.skelition = false)
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  confirmRedo() {
    if (!this.currentFactor.redoReason) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            channelId: this.currentFactor.channel,
            branchId: this.currentFactor.branch,
            factorId: this.currentFactor._id,
            approvalStatus: 'Redo',
            repeat: this.currentFactor.factorResponsible.repeat + 1,
            comments: this.currentFactor.redoReason
          };
          this.skelition = true;
          this.showRedoModal = false;
          let res = await this.dataService.postData('ms-factors/status/approval', approveData, 'PUT', false);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.getFactorData().then(() => this.skelition = false)
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  getResponsible(id: string) {
    return this.project?.responsibles?.find((r: any) => r.user._id == id);
  }

  async updateResponsible() {
    if (this.currentFactor && this.currentFactor.responsible) {
      this.showForwardModal = false;
      this.skelition = true;
      try {
        let payload: any = {
          projectId: this.currentFactor.projectId,
          channelId: this.currentFactor.channel,
          branchId: this.currentFactor.branch,
          factorId: this.currentFactor._id,
          responsible: this.currentFactor.responsible
        };
        let res = await this.dataService.postData('ms-factors/responsible/update', payload, 'PUT')
        this.skelition = false;
        if (res.error) {
          return;
        }
        this.currentFactor = null;
        this.getFactorData().then(() => this.skelition = false);
      } catch (e) {
        this.skelition = false;
        console.log(e);
      }
    } else {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Responsible can\'t be empty') },
      ]
    }
  }

  isApproved(factor: any) {
    return factor?.factorResponsible?.approvalStatus == 'Approved';
  }

  ShowFactor(factor: any) {
    console.log("Factor", factor)

    const grades = factor?.factors?.grade;
    const sum = grades.reduce((acc: number, grade: number) => acc + grade, 0);
    const average = sum / grades.length;

    console.log(average + " < " + factor.factor_cutoff)

    if (average < factor.factor_cutoff) {
      return true;
    }
    else {
      return false;
    }
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getFactorData() {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-evaluation/factor-view/${this.projectId}?isJunior=${this.isJunior}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.factors = res.data.map((f: any) => {
        f.factors.grade = (f.factors.grade.reduce((acc: number, currentValue: number) => acc + currentValue, 0)) / f.factors.grade.length;
        f.factors.percentage = (f.factors.percentage.reduce((acc: number, currentValue: number) => acc + currentValue, 0)) / f.factors.percentage.length
        f.factors.msComments = f.factors.msComments.join(', ')
        if (f.factorResponsible) {
          f.factor_details.status = f.factorResponsible.status;
          f.rsComments = f.factorResponsible.rsComments;
          f.responsible = f.factorResponsible.responsible
        }
        if (f.factors.grade < f.factor_cutoff) {
          return f;
        }
        else {
          return null;
        }
        return f;
      }).filter((f: any) => f !== null);

    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async assignResponsible() {
    this.skelition = true;
    try {
      let payload: any[] = this.factors.map(f => {
        return {
          projectId: f.projectId,
          channelId: f.channel,
          branchId: f.branch,
          factorId: f._id,
          responsible: f.responsible
        }
      });
      let res = await this.dataService.postData('ms-factors/responsible/assign', payload)
      this.skelition = false;
      if (res.error) {
        console.log(res.msg)
        return;
      }
      this.messages = [{ severity: 'success', summary: this.translate('success') }]
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  async updateStatus() {
    this.skelition = true;
    try {
      let payload: any[] = this.factors.map(f => {
        return {
          channelId: f.channel,
          branchId: f.branch,
          factorId: f._id,
          responsible: f.responsible,
          status: f.factor_details.status,
          approvalStatus: (f.factorResponsible.approvalStatus == 'Redo' || f.factorResponsible.approvalStatus == undefined) ? 'Pending' : f.factorResponsible.approvalStatus,
          comments: f.rsComments,
        }
      });
      let res = await this.dataService.postData('ms-factors/status/update', payload, 'PUT')
      this.skelition = false;
      if (res.error) {
        console.log(res.msg)
        return;
      }
      this.messages = [{ severity: 'success', summary: this.translate('success') }]
    } catch (e) {
      this.skelition = false;
      console.log(e);
    }
  }

  extractUsername(name: any) {
    if (name) {
      return name.first + ' ' + name.middle + ' ' + name.last;
    }
    return ''
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }
}
